/// ▲ score ▼ control. Clicking the arrow you've already used
/// retracts the vote; clicking the other flips it. `score` is the
/// already-optimistically-adjusted value the parent passes in.

import type { VoteValue } from '../data/devBlog'

export function DevBlogVoteControl(props: {
  score: number
  myVote: VoteValue | null
  disabled?: boolean
  onVote: (next: VoteValue | null) => void
}) {
  const toggle = (v: VoteValue) => {
    if (props.disabled) return
    props.onVote(props.myVote === v ? null : v)
  }
  return (
    <div className="flex w-8 shrink-0 flex-col items-center gap-0.5 text-slate-400">
      <button
        type="button"
        aria-label="Upvote"
        disabled={props.disabled}
        onClick={() => toggle(1)}
        className={
          'leading-none transition-colors ' +
          (props.myVote === 1 ? 'text-emerald-400' : 'hover:text-slate-200') +
          (props.disabled ? ' opacity-50' : '')
        }
      >
        ▲
      </button>
      <span
        className={
          'min-w-[2ch] text-center text-xs font-semibold tabular-nums ' +
          (props.score > 0 ? 'text-emerald-300' : props.score < 0 ? 'text-rose-300' : 'text-slate-400')
        }
      >
        {props.score}
      </span>
      <button
        type="button"
        aria-label="Downvote"
        disabled={props.disabled}
        onClick={() => toggle(-1)}
        className={
          'leading-none transition-colors ' +
          (props.myVote === -1 ? 'text-rose-400' : 'hover:text-slate-200') +
          (props.disabled ? ' opacity-50' : '')
        }
      >
        ▼
      </button>
    </div>
  )
}
